import { get } from "../index";

export const getTracking = (data) => {
  return get(`/tracking/${data?.id}/${data?.company}`);
};
